import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";

const useCalculateProratedCost = (subscriptionId, additionalSeats, currency, enabled = false) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		if (!subscriptionId || !additionalSeats) return null;

		const instance = await InitApi({ accessToken });
		const res = await instance.get(`subscriptions/${subscriptionId}/calculate-prorated-cost`, {
			params: {
				additional_seats: additionalSeats,
				currency: currency,
			},
		});
		return res.data;
	};

	return useQuery(
		["calculate-prorated-cost", subscriptionId, additionalSeats, currency],
		() => fetch(),
		{
			enabled: enabled && !!subscriptionId && !!additionalSeats,
			staleTime: 0,
			cacheTime: 0,
		}
	);
};

export default useCalculateProratedCost;
